import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jiaoyi",
  "use": "icon-jiaoyi-usage",
  "viewBox": "0 0 32 29",
  "content": "<symbol viewBox=\"0 0 32 29\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-jiaoyi\">\n    <!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com -->\n    <title>jiaoyi@2x</title>\n    <desc>Created with Sketch.</desc>\n    <g id=\"icon-jiaoyi_jiaoyi\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\">\n        <path d=\"M22.4674431,2 L28.7539319,8.17504827 C29.2751611,8.6870494 28.9143545,9.56310559 28.1773049,9.5750093 L2,10\" id=\"icon-jiaoyi_Stroke-1\" stroke=\"#5C7DFF\" stroke-width=\"3.3\" />\n        <path d=\"M8.5353301,27 L8.5353301,27 L2.24611232,20.830157 C1.7248849,20.3188229 2.08550154,19.4438074 2.82260831,19.4316328 L29,19\" id=\"icon-jiaoyi_Stroke-3\" stroke=\"#5C7DFF\" stroke-width=\"3.3\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/jiaoyi.svg
// module id = jp7U
// module chunks = 107